module.exports = __webpack_public_path__ + "static/media/tree-step_soil.d6a38206.svg";